export function StatsSection() {
  const stats = [
    { value: '500,000+', label: '注册用户' },
    { value: '200万+', label: '生成文章数' },
    { value: '98.5%', label: '用户满意度' },
    { value: '30+', label: '覆盖行业' },
  ];

  return (
    <section className="py-10 md:py-12 bg-background-50 border-b border-background-200/60">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8">
          {stats.map((stat) => (
            <div key={stat.label} className="text-center">
              <div className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
                {stat.value}
              </div>
              <div className="text-sm text-foreground-500 mt-1">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}